var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.239,
    height: 24.239,
    viewBox: "0 0 24.239 24.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-edit",
    transform: "translate(-1.617 -5.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M75.509,14.071a.116.116,0,0,0,.038-.084.119.119,0,0,0-.038-.084L72.8,11.2a.116.116,0,0,0-.165,0L70.65,13.186l2.873,2.873Z",
    transform: "translate(-51.325 -4.342)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M29.552,32.549,29.07,35.9l3.344-.484,9.629-9.629L39.181,22.92Z",
    transform: "translate(-20.995 -12.918)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M64.32,16.553h0l0,0Z",
    transform: "translate(-46.708 -8.272)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M28.628,16.092a.812.812,0,0,0-.812.812v9.5a1.426,1.426,0,0,1-1.423,1.423H8.247A1.426,1.426,0,0,1,6.823,26.4V8.257A1.426,1.426,0,0,1,8.247,6.833h9.5a.812.812,0,1,0,0-1.623h-9.5A3.052,3.052,0,0,0,5.2,8.257V26.4a3.052,3.052,0,0,0,3.047,3.047H26.393A3.049,3.049,0,0,0,29.439,26.4V16.9A.812.812,0,0,0,28.628,16.092Z",
    transform: "translate(-3.583)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.a6762284a392f1d3b4efcf120167bf25.svg";
export { ForwardRef as ReactComponent };